<template>
  <div class="form-group">
    <validation-item
      :label="label"
      :name="validationFieldName"
      :rules="rules"
      :vid="vid"
    >
      <template v-slot="errors">
        <multiselect
          v-if="typeof options[0] === 'object'"
          :class="{ 'is-invalid': errors.errors && errors.errors.length > 0 }"
          :multiple="multiple"
          :options="options"
          :label="
            typeof optionTextKey === 'string' ? optionTextKey : optionTextKey[0]
          "
          :placeholder="placeholder"
          :track-by="optionValueKey"
          v-model="innerValue"
          :allow-empty="allowEmpty"
          selectLabel=""
        >
          <template slot="option" slot-scope="props">
            <span v-if="typeof optionTextKey === 'string'">
              {{ props.option[optionTextKey] }}
            </span>
            <span v-else>
              <span v-for="(item, i) in optionTextKey" :key="item">
                {{ props.option[item] }}
                <span v-if="i < optionTextKey.length - 1">-</span>
              </span>
            </span>
          </template>
        </multiselect>
        <multiselect
          v-else
          :class="{ 'is-invalid': errors.errors && errors.errors.length > 0 }"
          :multiple="multiple"
          :options="options"
          :placeholder="placeholder"
          v-model="innerValue"
          :disabled="disabled"
        >
        </multiselect>
      </template>
    </validation-item>
  </div>
</template>

<script>
import ValidationItem from './ValidationItem'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ValidationSelect',
  components: { ValidationItem, Multiselect },
  props: {
    label: {
      type: String,
      default: '',
    },
    validationFieldName: {
      type: String,
      default: '',
    },
    rules: {
      type: [String, Object, Array],
      default: '',
    },
    vid: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Array, Object],
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    optionTextKey: {
      type: [String, Array],
      default: undefined,
    },
    optionValueKey: {
      type: String,
      default: undefined,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      innerValue: this.multiple ? [] : '',
    }
  },
  watch: {
    value(value) {
      this.innerValue = value
    },
    innerValue(newValue) {
      this.$emit('input', newValue)
    },
  },
  mounted() {
    if (this.value !== '' || this.value.length > 0) this.innerValue = this.value
  },
  methods: {
    handleInputChange(value) {
      console.log(value)
    },
  },
}
</script>

<style scoped></style>
